import React, { Component } from 'react';
import { passwordReset } from '../../requests/AccountUserRequests.js';
import * as commonFunctions from '../../utils/CommonFunctions.js';
import { Input } from 'reactstrap';
import DocumentTitle from 'react-document-title';
import '../../css/login/Login.css';
import { connect } from 'react-redux';
import { showAlert } from '../../actions/Actions.js';

class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        };
    }

    passwordReset = () => {
        if (commonFunctions.isValidEmail(this.state.email)) {
            const paramsObject = {
                email: this.state.email,
            };
            passwordReset(paramsObject)
                .then(res => {
                    // M7-326: we now email a reset LINK, not a temporary password,
                    // and the backend always responds success (anti-enumeration).
                    // Both branches therefore show the SAME neutral wording and
                    // route to /login, so no path ever reveals whether the address
                    // matched an account — the former "we couldn't find an account"
                    // message was both dead code and an enumeration oracle.
                    this.props.showAlert(
                        'If that email matches an account, we’ve sent a password-reset link. Check your inbox.',
                        'positive'
                    );
                    this.props.history.push('/login');
                })
                .catch(error => {
                    this.props.showAlert(
                        'We were unable to reset your password at this time',
                        'negative'
                    );
                });
        } else {
            this.props.showAlert('Please provide a valid email', 'warning');
        }
    };

    render() {
        return (
            <div className="lContainer">
                <DocumentTitle title="Password Reset" />
                <div className="lSignInText">Reset Your Password</div>
                <div className="lInputContainer cardContainer">
                    <div className="lPasswordResetInstruction">
                        Enter the email associated with your account and we'll email you a link to
                        reset your password.
                    </div>
                    <div className="lLabelAndInput">
                        <div className="lLabel">Email</div>
                        <Input
                            onChange={newEmail =>
                                this.setState({
                                    email: newEmail.target.value,
                                    invalidEmail: false,
                                })
                            }
                            type="text"
                        />
                    </div>
                    <div className="lForgotPasswordRow">
                        <button
                            type="button"
                            className="lForgotPasswordLink"
                            onClick={() => this.props.history.push('/login')}
                        >
                            Login
                        </button>
                    </div>
                    <div className="lButtonContainer">
                        <button className="primaryButton" onClick={this.passwordReset}>
                            Reset Password
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
    { showAlert }
)(PasswordReset);
